(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Resources.Greece",
                {
                    url: "/Greece",
                    component: "greece",
                    PageTitle: "Athens, Greece",
                    requiredPermissions: "Greece:View",
                    resolve: {
                        states: ["states", function (states) {
                            return states;
                        }]
                    }
                });
        }
    ]);

    app.component("greece",
        {
            templateUrl: "App/Resources/Greece/greece.html",
            controller: greeceCtrl,
            bindings: {
                states: "<"
            }
        });

    greeceCtrl.$inject = ["amplitudeService"];

    function greeceCtrl(amplitudeService) {
        var $ctrl = this;

        $ctrl.logAmplitude = function (propertyName) {
            return amplitudeService.logClickEvent(propertyName);
        };
       
    }
})(window.app, window.angular); // jshint ignore:line